import { useEffect } from 'react';

interface SchemaMarkupProps {
  type: 'LocalBusiness' | 'Service' | 'FAQ';
  data: any;
}

const SchemaMarkup = ({ type, data }: SchemaMarkupProps) => {
  useEffect(() => {
    let schema: any = {};

    switch (type) {
      case 'LocalBusiness':
        schema = {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "@id": "https://blueknightcontracting.ca",
          "name": "Blue Knight Contracting and Construction",
          "alternateName": "Blue Knight Contracting",
          "description": "Blue Knight Contracting and Construction is Ontario's trusted general contractor providing residential, commercial, and industrial construction services across the province.",
          "url": "https://blueknightcontracting.ca",
          "telephone": "(416) 555-2583",
          "email": "info@blueknightcontracting.ca",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Toronto",
            "addressRegion": "Ontario",
            "addressCountry": "Canada"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "43.6532",
            "longitude": "-79.3832"
          },
          "areaServed": [
            {
              "@type": "State",
              "name": "Ontario"
            },
            {
              "@type": "City",
              "name": "Toronto"
            },
            {
              "@type": "City", 
              "name": "Ottawa"
            },
            {
              "@type": "City",
              "name": "Mississauga"
            },
            {
              "@type": "City",
              "name": "Hamilton"
            },
            {
              "@type": "City",
              "name": "London"
            },
            {
              "@type": "City",
              "name": "Windsor"
            },
            {
              "@type": "City",
              "name": "Kingston"
            }
          ],
          "serviceType": [
            "General Contracting",
            "Construction Services",
            "Electrical Services",
            "Plumbing Services", 
            "HVAC Services",
            "Excavation Services",
            "Carpentry Services"
          ],
          "foundingDate": "2004",
          "founder": {
            "@type": "Organization",
            "name": "Blue Knight Contracting and Construction"
          },
          "employee": {
            "@type": "QuantitativeValue",
            "minValue": 50,
            "unitText": "employees"
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "127"
          },
          "paymentAccepted": "Cash, Check, Credit Card, Financing Available",
          "priceRange": "$$-$$$",
          "openingHours": [
            "Mo-Fr 07:00-18:00",
            "Sa 08:00-16:00"
          ],
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Construction Services",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "General Contracting Ontario",
                  "description": "Complete project management for residential, commercial, and industrial construction projects across Ontario."
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service", 
                  "name": "Electrical Services Toronto",
                  "description": "Licensed electricians providing electrical installations, repairs, and upgrades in Toronto and GTA."
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Plumbing Services Hamilton",
                  "description": "Professional plumbing services including installation, repair, and maintenance in Hamilton and surrounding areas."
                }
              }
            ]
          }
        };
        break;

      case 'Service':
        schema = {
          "@context": "https://schema.org",
          "@type": "Service",
          "serviceType": data.serviceType,
          "provider": {
            "@type": "LocalBusiness", 
            "name": "Blue Knight Contracting and Construction"
          },
          "areaServed": {
            "@type": "State",
            "name": "Ontario"
          },
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": data.serviceName,
            "itemListElement": data.services
          }
        };
        break;

      case 'FAQ':
        const faqArray = Array.isArray(data) ? data : data.faqs || [];
        schema = {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqArray.map((faq: any) => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        };
        break;
    }

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      if (script.parentNode === document.head) {
        document.head.removeChild(script);
      }
    };
  }, [type, data]);

  return null;
};

export default SchemaMarkup;